import { Injectable } from '@angular/core';
import { HttpGeneralService, EmergencyParms } from '../../shared';
import { CONFIG } from '../../shared/config';
import { CallData } from '../call-center-reservation';
import { GenModuleSettingService } from '../../shared/gen-module-setting.service';
let stockTransUrl = CONFIG.baseUrls.StockTrans;

let callCenterlistUrl = CONFIG.baseUrls.emergencyReservation;

@Injectable()
export class CallCenterService {
  constructor(private httpGeneralService: HttpGeneralService,  private _MS: GenModuleSettingService
  ) { }
  // مركز الاتصالات
  getCallsData(callCenterParms: EmergencyParms) {
    return this.httpGeneralService.search(callCenterParms, `${callCenterlistUrl}/GetCallList`)
  }
  // جلسات الجلديه
  getLaserSessionData(laserSessionParms: EmergencyParms) {
    return this.httpGeneralService.search(laserSessionParms, `${callCenterlistUrl}/GetLaserSessionList`)
  }
  //حجوزات العيادات
  getClinicData(clinicParms: EmergencyParms) {
    return this.httpGeneralService.search(clinicParms, `${callCenterlistUrl}/GetClinicList`)
  }

  //Sech Messages
  markPatSechMessagesLoad(clinicParms: EmergencyParms) {
    return this.httpGeneralService.search(clinicParms, `${callCenterlistUrl}/markPatSechMessagesLoad`)
  }

  /******************************************************************/
  getCallerDataSerach(callCenterParms: EmergencyParms) {
    return this.httpGeneralService.search(callCenterParms, `${callCenterlistUrl}/GetCallerDataSerach`)
  }
  downloadExcelSheet(callCenterParms: EmergencyParms, responseType: string) {
    return this.httpGeneralService.getFileByPost(callCenterParms, `${callCenterlistUrl}/ExportEMRDataToExcel`, responseType);
  }
  getEMRDownloadExcelURL() {
    return `${callCenterlistUrl}/ExportEMRDataToExcel`
  }

  changeCallerStatus(callerParms: CallData) {
    return this.httpGeneralService.post(callerParms, `${callCenterlistUrl}/changeCallerStatus`)
  }
  confarmationReservationCall(callerParms: CallData) {
    return this.httpGeneralService.post(callerParms, `${callCenterlistUrl}/ConfarmationReservationCall`)
  }

 
  getStockModuleSettings(parms: any) {
    return this._MS.getStockModuleSettings(parms);
  }

  getCcPublicData(callCenterParms: EmergencyParms) {
    return this.httpGeneralService.search(callCenterParms, `${callCenterlistUrl}/getCcPublicData`)
  }
}
